<div class="animated slideInRight">
    <div>

        <div class="row mx-0 my-3">
            <div class="col-md-3 p-0">
                <sanabel-selectize #secLoginSeclectize (clicked)="SecLoginsClicked($event)"
                    [SearchKeys]="{'SecUserId':userId}" appcode="1063"></sanabel-selectize>
            </div>
            <div class="col-md-3">
                <label for="search">{{ 'FASTSEARCH' | translate }}</label>
                <input #gb size="30" id="search" pInputText type="text" placeholder="{{ 'FILTER' | translate }}"
                    class="form-control">
            </div>
            <div class="col-md-3" *ngIf="showAppCodesStpSelectize">
                <sanabel-selectize appcode="1265" [multi]="true" (addSelected)="admAppCodesStpClicked($event)">
                </sanabel-selectize>
            </div>
        </div>
        <tab-ctrl #tab [appCodes]="[6584,6585]" [defaultTab]="defaultTab" (clicked)="activateTab($event)"></tab-ctrl>
        <div *ngIf="activeTabSerial == 6585 " [hidden]="activeTabSerial!= 6585">
            <div class="col-4">
                <input #gb class="form-control" type="text" pInputText placeholder="{{ 'FILTER' | translate }}">
            </div>
            <!-- <input type="text" placeholder="Search" (keyup)="searchinAppCodes($event.target.value)"> -->
            <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped"
                [value]="userAppCodesFilter" [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"
                [rowsPerPageOptions]="[5,10,20,50,100]" [globalFilter]="gb">
                <p-column field="appCode" header="{{ 'CODE' | translate }}" [sortable]="true"></p-column>
                <p-column field="appCodeNameAr" header="{{ 'ARABICNAME' | translate }}" [sortable]="true"></p-column>
                <p-column field="appCodeNameEn" header="{{ 'ENGLISHNAME' | translate }}" [sortable]="true"></p-column>
                <p-column header="{{ 'InOutFlag' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <span *ngIf="row.dataStatus!=2 && row.dataStatus!=1">{{row.inOutFlagName}}</span>
                        <div *ngIf="row.dataStatus==2||row.dataStatus==1">
                            <select class="form-control form-control-sm" [(ngModel)]="row.inOutFlag" name="inOutFlag">
                                <option [value]="0">Include</option>
                                <option [value]="1">Exclude</option>
                            </select>
                        </div>
                    </ng-template>
                </p-column>
                <p-column styleClass="col-button" header="{{ 'ACTION' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="onRowIconClick($event , row)" [appCodes]="[403,402]"></icon-action>
                    </ng-template>
                </p-column>
            </p-dataTable>
        </div>
        <!--table area-->
        <!--header for column name & field for column content-->
        <div class="card panel-default" *ngIf="activeTabSerial == 6584 " [hidden]="activeTabSerial!= 6584">
            <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped"
                [value]="childLinks" [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"
                [rowsPerPageOptions]="[5,10,20,50,100]" [globalFilter]="gb">
                <p-column field="code" header="{{ 'CODE' | translate }}" [sortable]="true"></p-column>
                <p-column field="nameAr" header="{{ 'ARABICNAME' | translate }}" [sortable]="true"></p-column>
                <p-column field="nameEn" header="{{ 'ENGLISHNAME' | translate }}" [sortable]="true"></p-column>
                <p-column styleClass="col-button">
                    <ng-template pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="onRowIconClick($event , row)" [appCodes]="[404]"></icon-action>
                    </ng-template>
                </p-column>
            </p-dataTable>
        </div>

        <!--عشان اجيب اللنكات اللى تبع اليوزر ده-->
        <!--<div class="row">
            <div class="col-sm-4 nav-item" *ngFor="let link of childLinks">
                <div class="mdl-tabs__tab is-active " style="text-decoration:underline;" (click)="getAppCodesByLinkIds(link)">{{link.nameAr}}</div>
            </div>
        </div>-->
        <div class="row mx-0" *ngIf="activeTabSerial != 6585 ">
            <div class="card col-6">
                <div class="card-block row pt-1">
                    <div class="col-12 pb-3">
                        <h3>{{translate.currentLang == 'ar' ? 'خطوات يتم استبعادها' : 'Excluded Steps'}}</h3>
                    </div>
                    <div class="col-sm-4" *ngFor="let appcode of selectedAppCodes;let i=index">
                        <div class="form-check px-0">
                            <label [attr.for]="i">
                                <input type="checkbox" [id]="i" [(ngModel)]="appcode.selected" />
                                <span>
                                    {{appcode.nameAr}}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card col-6">
                <div class="card-block row pt-1">
                    <div class="col-12 pb-3">
                        <h3>{{translate.currentLang == 'ar' ? 'خطوات يتم اضافتها' : 'Included Steps'}}</h3>
                    </div>
                    <div class="col-sm-4" *ngFor="let appcode of unselectedAppCodes;let i=index">
                        <div class="form-check px-0">
                            <label [attr.for]="i">
                                <input type="checkbox" [id]="i" [(ngModel)]="appcode.selected" />
                                <span>
                                    {{appcode.nameAr}}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <btns-ctrl [paramsArr]="controlsParams" (clicked)="onClicked($event)"></btns-ctrl>
                </div>
            </div>
        </div>
    </div>
</div>